/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Event_DisapprovedInputs */



/**
* | output |
* | --- |
* | "Event marked as disapproved." |
*
* @param {Error_Nav_Event_DisapprovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_event_disapproved = /** @type {((inputs?: Error_Nav_Event_DisapprovedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Event_DisapprovedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Evenement marque comme desapprouve.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Veranstaltung wurde als abgelehnt markiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento contrassegnato come non approvato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Мероприятие помечено как отклоненное.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento marcado como desaprobado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活动被标记为不予批准。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントは不承認としてマークされました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस आयोजन को अस्वीकृत घोषित किया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento marcado como reprovado.")
	return /** @type {LocalizedString} */ ("Event marked as disapproved.")
});